<div id="statusElement">
  <app-status-card [title]="statusCardData.title" [statusText]="statusCardData.statusText"
    [statusClass]="statusCardData.statusClass" [infoBoxMessage]="statusCardData.infoBoxMessage"
    [details]="statusCardData.details" [infoText]="statusCardData.infoText" [requestTitle]="statusCardData.requestTitle"
    [requestDescription]="statusCardData.requestDescription" [requestLink]="statusCardData.requestLink"
    [requestLinkText]="statusCardData.requestLinkText" [infoImportant]="statusCardData.infoImportant"
    [requestDescriptionInfoImportant]="statusCardData.requestDescriptionInfoImportant"
    [requestTitleImportant]="statusCardData.requestTitleImportant"
    [infoImportantStrong]="statusCardData.infoImportantStrong" [tieneCertificadoOfertas]="tieneCertificadoOferta"
    (descargarCertificadoOfertas)="openModalDescarga()"></app-status-card>
</div>


<div *ngFor="let faq of faqCards" [id]="faq.id">
  <app-faq-card [faqs]="faq.data" [subTitleFaq]="faq.subTitle" [titleFaq]="faq.title"></app-faq-card>
</div>